// extracted by mini-css-extract-plugin
export var cardIcon = "_6u-4";
export var checkboxCard = "_6u-0";
export var checkboxCardSelected = "_6u-3";
export var disabled = "_6u-1";
export var outerBorder = "_6u-2";
export var spacerMedium = "_6u-7";
export var spacerSmall = "_6u-6";
export var spacerXsmall = "_6u-5";